import { render } from "./TabooPatternModal.vue?vue&type=template&id=973367ba"
import script from "./TabooPatternModal.vue?vue&type=script&lang=js"
export * from "./TabooPatternModal.vue?vue&type=script&lang=js"

import "./TabooPatternModal.vue?vue&type=style&index=0&id=973367ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__